export const constantApi = {
  listRegions: '/clouddm/console/api/v1/constant/region',
  listRegionAreas: '/clouddm/console/api/v1/constant/listregionareas',
  listCloudOrIdcNames: '/clouddm/console/api/v1/constant/cloudoridcname',
  listSupportedRegions: '/clouddm/console/api/v1/constant/supportedregion',
  fetchLicenseFunctionResource: '/cloudcanal/console/api/v1/inner/constant/fetchlicensefunctionresource'
};
